export default __webpack_public_path__ + "static/media/cancel.828f6190.png";